import brandStying from './brandStying.vue'

export default brandStying
